import comp from "./AIPanelInputBox";
export default comp;
